<template>
    <div class="main">
        <div>
            <b-navbar
                toggleable="lg"
                type="dark"
                variant="info"
                class="navbar-dark bg-dark"
            >
                <div>
                    <router-link style="margin-right: 10px" to="/botiboti.html"
                        >通常版</router-link
                    >
                    <router-link to="/botiboti_light.html">軽量版</router-link>
                </div>
                <div class="d-flex flex-row align-items-center ml-auto">
                    <div>
                        <b-form-input
                            size="sm"
                            class="mr-sm-1 search"
                            placeholder="検索"
                            type="text"
                            ref="searchRef"
                            v-model="search"
                            @keyup.enter="onSeachEnter"
                            @focus="controlShow = false"
                            @blur="controlShow = true"
                        ></b-form-input>
                    </div>
                    <div class="ml-3 mr-2">
                        <div
                            class="icon icon-check"
                            @click="offSelect"
                            v-if="selectMode"
                        ></div>
                        <div
                            class="icon icon-no-check"
                            @click="onSelect"
                            v-if="!selectMode"
                        ></div>
                    </div>
                    <div class="mx-2">
                        <div
                            class="icon icon-fav"
                            @click="offFav"
                            v-if="favMode"
                        ></div>
                        <div
                            class="icon icon-no-fav"
                            @click="onFav"
                            v-if="!favMode"
                        ></div>
                    </div>
                </div>
            </b-navbar>
        </div>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col m-0 p-0">
                    <audio-banner
                        :audio-item="sharedState.bannerItem.data"
                    ></audio-banner>
                </div>
            </div>
        </div>

        <div class="container px-0" v-show="!selectionMode">
        <main-buttons :search-word="this.search" v-if="!favMode"></main-buttons>
        <fav-buttons v-if="favMode"></fav-buttons>
        </div>
        <div class="container px-0" v-show="selectionMode">
            <div class="row justify-content-center">
                <div class="col m-0 p-0">
                    <audio-buttons
                        :audio-items="sharedState.selectedItems.data"
                        :button-type="miniButtonType"
                        v-show="selectionMode"
                    ></audio-buttons>
                </div>
            </div>
        </div>

        <div v-show="sharedState.selectMode.data">
            <edit-control @to-button-page="moveToSelectedButtonPage">
            </edit-control>
        </div>
        <transition name="control-fade">
            <div v-show="controlShow && !sharedState.selectMode.data">
                <control></control>
            </div>
        </transition>
        <div style="height: 150px"></div>
    </div>
</template>

<script>
import AudioButtons from '@/components/AudioButtons.vue'
import AudioBanner from '@/components/AudioBanner.vue'
import Control from '@/components/Control.vue'
import Global from '@/mixins/global'
import AudioSourcePlayable from '@/mixins/AudioSourcePlayable'
import MainButtons from '@/components/MainButtons.vue'
import FavButtons from '@/components/FavButtons.vue'
import EditControl from '@/components//EditControl.vue'
import store from '../store/store'

export default {
    name: 'Main',
    props: {
        pageType: {
            type: String,
        },
    },
    components: {
        MainButtons,
        FavButtons,
        AudioButtons,
        AudioBanner,
        Control,
        EditControl,
    },
    mixins: [Global, AudioSourcePlayable],
    localStorage: {
        buttonFavs: {
            type: Object,
            default: {},
        },
    },
    data: function () {
        return {
            data_dir: '',
            search: '',
            controlShow: true,
            sharedState: store.state,
        }
    },
    created() {
        const params = { ver: Math.random().toString(32).substring(2) }
        const buttondataUrl = this.generateDataPath('buttondata.json', params)

        store.setPageType(this.pageType)

        fetch(buttondataUrl, {
            method: 'GET',
            cache: 'no-cache',
        })
            .then(function (response) {
                return response.json()
            })
            .then((buttonJsonData) => {
                store.loadAudioSources(buttonJsonData)
                store.setFavToAudioSources(this.$localStorage.get('buttonFavs'))
                store.favs.setLovalStorageFavs(this.$localStorage.get('buttonFavs'))
                store.favs.initFavItems(store.getAllItems())

                const defaultItem = store.getbannerItem()
                store.history.putHistory(defaultItem)

                this.initSelectedItem(this.$route.query)
            })

        const videoInfoUrl = this.generateDataPath('video_info.json', params)
        fetch(videoInfoUrl, {
            method: 'GET',
            cache: 'no-cache',
        })
            .then((response) => response.json())
            .then((videoinfo) => store.loadVideoInfos(videoinfo))
    },
    computed: {
        favMode: function () {
            return store.getFavMode()
        },
        selectMode: function () {
            return store.getSelectMode()
        },
        selectionMode: function () {
            return (
                store.getSelectMode() === false &&
                store.getPageState() === 'selection'
            )
        },
        miniButtonType: function () {
            switch (this.pageType) {
                case 'light':
                    return 'button'
                case 'normal':
                    return 'mini'
                default:
                    return 'mini'
            }
        },
    },
    watch: {
        $route(to) {
            this.onMovePage(to)
        },
    },
    methods: {
        onMovePage: function(to) {
            store.setPageType(this.pageType)
            this.initSelectedItem(to.query)
        },
        initSelectedItem: function (query) {
            store.setSelctedItems(query)
            store.setPageState('normal')

            store.setSelectMode(false)

            if (store.getSelectedItems().length !== 0) {
                store.setPageState('selection')
            }
            store.editControl.setEditControls(store.getSelectedItems())
        },
        onSelectModeChange: function (checked) {
            if (store.getPageState() === 'selection' && !checked) {
                this.moveToSelectedButtonPage()
            }
        },
        moveToSelectedButtonPage: function () {
            const serialIds = []
            for (const data of store.editControl.getEditControls()) {
                serialIds.push(data.item.serialId)
            }
            const queryB = serialIds.join('-')
            const url = this.$route.path + '?b=' + queryB

            if (this.$route.query.b !== queryB) {
                this.$router.push(url)
            }
        },
        onSeachEnter: function () {
            this.$refs.searchRef.blur()
        },
        onFav: function () {
            store.setFavMode(true)
        },
        offFav: function () {
            store.setFavMode(false)
        },
        onSelect: function () {
            store.setSelectMode(true)
        },
        offSelect: function () {
            store.setSelectMode(false)
        },
    },
}
</script>

<style scoped>
.control-fade-enter-active,
.control-fade-leave-active {
    transition: opacity 0.5s;
}
.control-fade-enter, .control-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.select-mode-toggle {
    width: 100%;
    color: white;
}
.main {
    height: 100%;
    min-height: 100vh;
    background-image: linear-gradient(-135deg, rgb(20, 0, 40), rgb(0, 0, 1));
}
.icon {
    width: 20px;
    height: 20px;
    background-size: contain;
    content: ' ';
}
.icon-fav {
    background-image: url('../assets/fav1.png');
}
.icon-no-fav {
    background-image: url('../assets/fav2.png');
}
.icon-check {
    background-image: url('../assets/check_on.png');
}
.icon-no-check {
    background-image: url('../assets/check_off.png');
}
.search {
    width: 150px;
}
</style>
<style>
body > .main {
    height: auto;
}
</style>
